import { useMemo } from "react"
import { Button, DialogActions, DialogContent } from "@mui/material"

import { BootstrapDialog, BootstrapDialogTitle } from "../../utils/bootstrapDialog";

import { SessionParamsEnum, ShuntParamsEnum } from "../../../enums";
import { useSessionParams, useShuntParams } from "../../../contexts";
import { useDatabase } from "reactfire";

export const ModifiedCalcDataModal = () => {
    const sessionParams = useSessionParams();
    const shuntParams = useShuntParams();
    const database = useDatabase();

    const openModal = useMemo(() => {
        if (ShuntParamsEnum.HasBeenRecalculated.getContextValue(shuntParams) === true) {
            return true;
        }
        else {
            return false;
        }
    }, [ShuntParamsEnum.HasBeenRecalculated.getContextValue(shuntParams)])

    const handleModalClose = () => {
        ShuntParamsEnum.HasBeenRecalculated.setContextValue(shuntParams, false, database, SessionParamsEnum.CurrentShunt.getContextValue(sessionParams));
    }

    return (
        <>
            <BootstrapDialog
                aria-labelledby="add-addon-modal"
                open={openModal}
            >
                <BootstrapDialogTitle onClose={handleModalClose}>
                    Anpassningar har återställts
                </BootstrapDialogTitle>

                <DialogContent sx={{ width: '400px' }} dividers>
                    <p>
                        Eventuella anpassningar som har gjorts har återställts till standardutförande efter shunten beräknades om.
                    </p>
                    <p>
                        Kontrollera och välj eventuella anpassningar igen.
                    </p>
                </DialogContent>

                <DialogActions>
                    <Button variant="outlined" onClick={handleModalClose}>OK</Button>
                </DialogActions>
            </BootstrapDialog>
        </>
    )
}